import React, { createContext, useContext, useState } from "react";

export interface QueryParams {
  // 任务编码
  subjectCode?: string;
  // 上传人
  createUser?: string;
  // 审核状态
  auditState?: string;
  // 租户编码
  tenantCode?: string;
  // 项目中心
  projectList?: string[];
  // 所属中心
  centerCode?: string;
}

export type QueryParamsType = keyof QueryParams;

interface Ctx {
  queryParams: QueryParams;
  setQueryParams: (params: QueryParams) => void;
  updateQueryParams: (params: QueryParams) => void;
}

const ContextNew = createContext<Ctx>({
  queryParams: {},
  setQueryParams: () => {},
  updateQueryParams: () => {},
});

interface ProviderProps {
  children: React.ReactNode;
}
export default function Provider({ children }: ProviderProps) {

  const [queryParams, setQueryParams] = useState<QueryParams>({});

  const updateQueryParams = (params: QueryParams) => {
    setQueryParams({ ...queryParams, ...params });
  };

  return (
    <ContextNew.Provider
      value={{
        queryParams,
        setQueryParams,
        updateQueryParams,
      }}
    >
      {children}
    </ContextNew.Provider>
  );
}

export const useAccoutContext = () => useContext(ContextNew);
